// todo
export const useAbsoluteUrl = () => {
  const url = useRequestURL();
  const getAbsoluteUrl = (path: any) => {
    return 'https://' + url.host + path;
  };

  return { getAbsoluteUrl };
};
